import { OneColumn } from 'components/page';
import { ConsultaReembolsoGrid, ConsultaReembolsoGridFilter, ConsultaReembolsoReport } from 'pages/financeiro/reembolso/consulta-reembolso/components';

export function ConsultaReembolsoListComp() {
    return (
        <OneColumn title="Consulta de Reembolsos" goBackButton>
            <ConsultaReembolsoGridFilter />

            <ConsultaReembolsoReport />

            <ConsultaReembolsoGrid />
        </OneColumn>
    );
}
